export const States = {
  MainMenu: "/",
  Game: "/game"
}
